import React, { useRef } from 'react';
import dynamic from 'next/dynamic';

import styles from './Slider.module.css';

const Slider = dynamic(import('react-slick'), {
  ssr: false
});

const SliderWrapper = ({ slides }) => {
  const carousel = useRef(null);
  return (
    <div className={`${styles.slider} relative`}>
      <Slider {...slideSettings} ref={carousel}>
        {slides.map((slide, i) => (
          <div className="px-1 sm:px-2 lg:px-3" key={`slider-${i + 1}`}>
            <div className="overflow-hidden">
              <img loading="lazy" className={styles.sliderImage} src={slide.url} alt={slide.alt} />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

const slideSettings = {
  draggable: true,
  centerPadding: '60px',
  centerMode: true,
  variableWidth: true,
  adaptiveHeight: true,
  dots: false,
  infinite: true,
  speed: 500,
  arrows: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        centerMode: true,
        centerPadding: '60px',
        variableWidth: false,
        adaptiveHeight: true,
        dots: false
      }
    }
  ]
};

export default SliderWrapper;
